import { Injectable, inject } from '@angular/core'
import {
    AbstractControl,
    FormGroup,
    NonNullableFormBuilder,
} from '@angular/forms'
import { SignupInput } from '@mattrika/benefit-model'
import { getUserInfoFormControls } from '../forms/user-info.form'

@Injectable({
    providedIn: 'root',
})
export class RegisterFormService {
    private fb = inject(NonNullableFormBuilder)
    form = this.buildForm()

    buildForm(): FormGroup {
        return this.fb.group({
            ...getUserInfoFormControls(),
        })
    }

    get firstName(): AbstractControl | null {
        return this.form.get('firstName')
    }

    get lastName(): AbstractControl | null {
        return this.form.get('lastName')
    }

    get email(): AbstractControl | null {
        return this.form.get('email')
    }

    get password(): AbstractControl | null {
        return this.form.get('password')
    }

    getValue(): Partial<SignupInput> {
        const formValue = this.form.value
        return {
            identifierType: 'email',
            identifierValue: formValue.email,
            password: formValue.password,
            firstName: formValue.firstName,
            lastName: formValue.lastName,
            phone: formValue.phone || undefined,
        }
    }

    patchForm(data: Partial<SignupInput>) {
        this.form.patchValue(data)
    }
}
